// @flow
import fp from "lodash/fp"
import { createSelector } from "reselect"
import type { OutputSelector } from "reselect"

import type { generalActions } from "./actions"
import {
  ANCILLARIES_3RD_ERROR,
  CHECK_ANCILLARIES_ERROR,
  CHECK_ANCILLARIES_LOADING,
} from "./actions"

export type AdditionalServiceState = {
  ancillaries3rd: {
    error: boolean,
  },
  checkAncillaries: {
    loaded: boolean,
    error: boolean,
  },
}

const DEFAULT_STATE = {
  ancillaries3rd: {
    error: false,
  },
  checkAncillaries: {
    loaded: false,
    error: false,
  },
}

const generalAncillariesReducer = (
  state: AdditionalServiceState = DEFAULT_STATE,
  action: generalActions,
) => {
  switch (action.type) {
    case ANCILLARIES_3RD_ERROR: {
      const payload = {
        ancillaries3rd: {
          error: true,
        },
      }
      return fp.merge(state)(payload)
    }
    case CHECK_ANCILLARIES_LOADING: {
      const payload = {
        checkAncillaries: {
          loaded: !action.loading,
        },
      }
      return fp.merge(state)(payload)
    }
    case CHECK_ANCILLARIES_ERROR: {
      const payload = {
        checkAncillaries: {
          loaded: true,
          error: action.error,
        },
      }
      return fp.merge(state)(payload)
    }
    default:
      return state
  }
}

export const ancillariesGeneral = (state: $FlowFixMe) =>
  fp.get("reservation.additionalServices.general")(state)

// eslint-disable-next-line flowtype/generic-spacing
export const ancillaries3rdLoadedSelector: OutputSelector<
  $FlowFixMe,
  mixed,
  boolean,
> = createSelector(
  ancillariesGeneral,
  fp.get("ancillaries3rd.loaded"),
)

// eslint-disable-next-line flowtype/generic-spacing
export const ancillaries3rdErrorSelector: OutputSelector<
  $FlowFixMe,
  mixed,
  boolean,
> = createSelector(
  ancillariesGeneral,
  fp.get("ancillaries3rd.error"),
)

// eslint-disable-next-line flowtype/generic-spacing
export const checkAncillariesLoadedSelector: OutputSelector<
  $FlowFixMe,
  mixed,
  boolean,
> = createSelector(
  ancillariesGeneral,
  fp.get("checkAncillaries.loaded"),
)

// eslint-disable-next-line flowtype/generic-spacing
export const checkAncillariesErrorSelector: OutputSelector<
  $FlowFixMe,
  mixed,
  boolean,
> = createSelector(
  ancillariesGeneral,
  fp.get("checkAncillaries.error"),
)

export default generalAncillariesReducer
